import { GetConsentsService } from "../../../../services/consents-services/get-consents.service";

const _ = require('lodash');
const stateName = 'primaryPrivacyView';

const acceptSettingsClassName = 'accept-settings-btn';
const denySettingsClassName = 'deny-settings-btn';
const showSecondaryBasicViewСlassName = 'show-secondary-basic-view';
const closeBtnClassName = 'close-modal-btn';

const centerModalPrimaryPrivacyTemplate1 = require('./templates/privacy-center-modal-templates/primary-privacy-center-modal-template-1.hbs');
const centerModalPrimaryPrivacyTemplate2 = require('./templates/privacy-center-modal-templates/primary-privacy-center-modal-template-2.hbs');

export default class PrimaryPrivacyViewController {
	private modalScope: any;
	private layoutParams: any;
	private languageService: any;
	private settingsService: any;

	private isVisible: boolean;

	private acceptSettingsBtns: any;
	private denySettingsBtns: any;
	private showSecondaryBasicViewBtns: any;
	private closeBtns: any;

	constructor(modalScope, layoutParams, utilityService) {
		this.layoutParams = layoutParams;
		this.languageService = utilityService.languageService;
		this.settingsService = utilityService.settingsService;
		this.modalScope = modalScope;

		this.isVisible = this.settingsService.centerModalVisibility;
	}

	private setState() {
		this.modalScope.changeState(stateName);
	}

	private getHtml() {
		let viewHTML: any;
		switch (this.layoutParams.modalView) {
		case 'center-modal-template-1':
		case 'center-modal-template-4':
		case 'center-modal-template-6':
		case 'center-modal-template-7':
		case 'center-modal-template-8':
		case 'center-modal-template-9':
		case 'center-modal-template-10':
		case 'center-modal-template-11':
		case 'center-modal-template-12':
			viewHTML = centerModalPrimaryPrivacyTemplate1;
			break;
		case 'center-modal-template-2':
		case 'center-modal-template-3':
		case 'center-modal-template-5':
			viewHTML = centerModalPrimaryPrivacyTemplate2;
			break;
		default:
			viewHTML = centerModalPrimaryPrivacyTemplate1;
			break;
		}
		return viewHTML({
			languageControl: this.modalScope.getModalWrapperElement()
				? this.languageService.htmlString(
					this.modalScope.getModalWrapperElement().id
				)
				: this.languageService.htmlString(),
			settings: this.settingsService.settings,
			elementsVisibility: this.settingsService.elementsVisibility,
			optInConsent: GetConsentsService.getOptinConsent(),
		});
	}

	public initHandling() {
		const self = this;

		if (self.visible) {
			self.acceptSettingsBtns = document.getElementsByClassName(
				acceptSettingsClassName
			);
			_.forEach(self.acceptSettingsBtns, acceptSettingsBtn => {
				acceptSettingsBtn.onclick = (event: any) => {
					//todo
					self.settingsService.acceptCookiesAgreement();
					self.settingsService.saveFirstUserInteraction();
					self.modalScope.closeModal();
				};
			});

			self.denySettingsBtns = document.getElementsByClassName(
				denySettingsClassName
			);
			_.forEach(self.denySettingsBtns, denySettingsBtn => {
				denySettingsBtn.onclick = (event: any) => {
					self.settingsService.denyAllCookiesExceptEssential();
					self.settingsService.saveFirstUserInteraction();
					self.modalScope.closeModal();
				};
			});

			self.showSecondaryBasicViewBtns = document.getElementsByClassName(
				showSecondaryBasicViewСlassName
			);
			_.forEach(self.showSecondaryBasicViewBtns, showSecondaryBasicViewBtn => {
				showSecondaryBasicViewBtn.onclick = (event: any) => {
					self.modalScope.changeState('secondary-basic');
					self.modalScope.updateView();
				};
			});

			self.closeBtns = document.getElementsByClassName(closeBtnClassName);
			_.forEach(self.closeBtns, closeBtn => {
				closeBtn.onclick = (event: any) => {
					self.modalScope.closeModal();
				};
			});
		}
	}

	public get visible() {
		return this.isVisible;
	}

	public set visible(_visible) {
		this.isVisible = _visible;
	}

	public get htmlString(): string {
		if (this.visible) {
			return this.getHtml();
		}
		return '';
	}
}
